import React from "react";
import {
    GridToolbarContainer, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";

export function CustomToolbar() {
    return (
        <GridToolbarContainer>
            {/*<GridToolbarColumnsButton/>*/}
            <GridToolbarFilterButton/>
            {/*<GridToolbarDensitySelector/>*/}
            <GridToolbarExport/>
        </GridToolbarContainer>
    );
}